import { ChipGroup, type ChipGroupItem } from "../ChipGroup";
import { FieldHelperRow } from "./FieldHelperRow";
import type { FieldValidation } from "./FieldShell";
export type MultiFieldFooterProps = {
  items: ChipGroupItem[];
  onRemove: (value: string) => void;
  /** Accessible name for the chip group — the field's label. */
  groupLabel: string;
  disabled?: boolean;
  validation?: FieldValidation;
  helperText?: string;
  /** Id the trigger's `aria-describedby` points at; stamped on the helper row. */
  helperTextId?: string;
  /** Forwarded to `ChipGroup` — focus target when a removal clears the group. */
  focusAfterLastRemove?: () => void;
};

/**
 * The chips-below tail of a multi-select field: the removable picks, then the
 * helper/validation row underneath. Shared by multi `Select` and `Combobox` so
 * the ordering and the trigger↔helper id link can't drift between them.
 */
export const MultiFieldFooter = ({
  items,
  onRemove,
  groupLabel,
  disabled = false,
  validation = "none",
  helperText,
  helperTextId,
  focusAfterLastRemove
}: MultiFieldFooterProps) => <>
    <ChipGroup items={items} onRemove={onRemove} groupLabel={groupLabel} disabled={disabled} focusAfterLastRemove={focusAfterLastRemove} data-sentry-element="ChipGroup" data-sentry-source-file="MultiFieldFooter.tsx" />
    <FieldHelperRow validation={validation} helperText={helperText} helperTextId={helperTextId} data-sentry-element="FieldHelperRow" data-sentry-source-file="MultiFieldFooter.tsx" />
  </>;